import React from 'react';
import { Card, Image } from 'semantic-ui-react';
import styled from 'styled-components';

export const GroupTile = () => (
  <CardContainer href='/'>
    <Card.Content textAlign='center' className='cardContent'>
      <Image
        src='/img/event/event-bg2.jpg' size='tiny' rounded
        floated='left'
      />
      <Card.Header>Long long long group name here</Card.Header>
      <Card.Description>This is a group for gathering all the tech lovers in Vancouver...</Card.Description>
    </Card.Content>
    <Card.Content extra textAlign='left'>
      <div className='members'>
        <div>
          <Image avatar src='/img/event/event-bg2.jpg' />
          <Image avatar src='/img/event/event-bg2.jpg' />
          <Image avatar src='/img/event/event-bg2.jpg' />
        </div>
        <span>15 members</span>
      </div>
    </Card.Content>
  </CardContainer>
);

const CardContainer = styled(Card)`
  &&.ui.card {
      width: 100%;
      height: 100%;
      background: #FFFFFF;
      box-shadow: none;
      border: 1px solid #E7EDF5;
      border-radius: 13px;    
  }
  &&.ui.card:hover {
  box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.1);
  }

  .members {
    display: flex;
    span {
      font-family: 'Lato';
    font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 19px;
      color: #676767;
    }

    div {
      display: flex;
    }

    div img {
        background: #fff;
        padding: 1px;
        z-index: 2;
    }
    div img:nth-child(2) {
        transform: translateX(-50%);
        z-index: 1;
    }
    div img:nth-child(3) {
        transform: translateX(-100%);
        z-index: 0;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/events/components/tile/groupTile.js